import axios from '@/lib/axios'
import { buildAdminRequestConfig } from '@/lib/organization-scoping'

export function getStripeMigration({ organizationId, signal }) {
  return axios.get('/stripe-connect/migration', {
    ...buildAdminRequestConfig({ organizationId }),
    signal,
  })
}

export function requestStripeMigration({ organizationId, action, surface }) {
  return axios.post(
    `/stripe-connect/migration${action === 'start' ? '' : `/${action}`}`,
    surface ? { surface } : null,
    buildAdminRequestConfig({ organizationId })
  )
}
